<template>
  <div class="self-assessment-form" v-loading="loading">
    <div
      v-if="!assessmentItemForm.item && pageType != 'detail'"
      class="add-item"
      @click="openDialog('assessment')"
    >
      <h2>企业自评表</h2>
      <p>
        <span class="cRed">*</span>
        <span>考核科目</span>
      </p>
    </div>
    <div
      class="assessment-item"
      v-if="assessmentItemForm.item && assessmentItemForm.item.length"
      @click="openDialog('assessment')"
    >
      <h2 class="subject-title">{{ assessmentItemForm.formTitle }}</h2>
      <el-table
        v-if="pageType != 'detail'"
        :data="formTableData"
        border
        style="width: 100%"
        :key="tableKey"
      >
        <el-table-column label="考核科目" width="180" prop="name">
        </el-table-column>
        <el-table-column
          v-for="(type, key) in assessmentItemForm.item"
          :key="key"
          :label="type.content"
        >
          <template slot-scope="scope">
            <div v-if="scope.$index == 0">
              {{ scope.row[`${type.content}-value`] }}%
            </div>
            <div v-else>{{ scope.row[`${type.content}-value`] }}</div>
          </template>
        </el-table-column>
        <el-table-column label="总分" width="180">
          <template slot-scope="scope">
            <div v-if="scope.$index == 0">{{ scope.row.totalScore }}%</div>
            <div v-else>{{ scope.row.totalScore }}</div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="add-title" v-if="pageType != 'detail'">
      <el-button type="primary" @click="openDialog('subject')"
        >添加题目</el-button
      >
    </div>
    <!-- 题目展示 -->
    <div class="subject-wrapper" v-if="subjectList.length">
      <div class="subject-item" v-for="(v, i) in subjectList" :key="i">
        <p>
          <span> {{ i + 1 }}. {{ `${v.formTitle}` }}</span>
          <el-button
            type="text"
            v-if="pageType !== 'detail'"
            @click="deleteSubjectItem(i)"
            >删除</el-button
          >
          <el-button
            v-if="pageType !== 'detail'"
            type="text"
            @click="editSubjectItem(i)"
            >编辑</el-button
          >
        </p>
        <div>
          <p
            class="answer-item"
            v-for="(item, itemIndex) in v.item"
            :key="itemIndex"
          >
            {{ enArr[itemIndex] }}. {{ `${item.content}` }}
          </p>
        </div>
      </div>
      <p v-if="assessmentItemForm.isFile">
        材料上传：请上传相关佐证材料，仅支持PDF文档
      </p>
    </div>
    <section class="btn-group">
      <el-button @click="goBack()">返回</el-button>
      <el-button
        v-if="$route.query.appraisalStatus != 1 && pageType == 'add'"
        @click="submitAllForm(0)"
        >保存草稿</el-button
      >
      <el-button
        v-if="pageType == 'add'"
        type="primary"
        @click="submitAllForm(1)"
        >发起</el-button
      >
    </section>
    <!-- 标题&考核项编辑 -->
    <el-dialog
      :title="dialogType == 'assessment' ? '标题&考核科目编辑' : '题目编辑'"
      :visible.sync="dialogVisible"
      :before-close="handleClose"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div>
        <el-form
          ref="dialogForm"
          :model="dialogForm"
          label-width="100px"
          :key="refreshKey"
        >
          <el-form-item label="需要上传附件" v-if="dialogType == 'assessment'">
            <el-switch
              v-model="dialogForm.isFile"
              active-color="#13ce66"
              inactive-color="#ff4949"
            >
            </el-switch>
            <span class="c999 ml10">
              <i class="el-icon-warning-outline"></i>
              若需要企业上传附件，开启题目即可，开启后，将在自评表最后一题下面新增一个附件上传题目，支持上传多个附件
            </span>
          </el-form-item>
          <el-form-item
            label="考核科目"
            v-if="dialogType == 'subject'"
            label-width="80px"
            prop="subjectContent"
            :rules="[
              { required: true, message: '请选择考核内容', trigger: 'change' },
            ]"
          >
            <el-select
              v-model="dialogForm.subjectContent"
              filterable
              placeholder="请选择"
            >
              <el-option
                v-for="item in options"
                :key="`${item.content}-${item.score}`"
                :label="item.content"
                :value="`${item.content}-${item.score}`"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <!-- 考核项编辑内容 -->
          <div>
            <div class="dialog-title no-border-bottom">
              {{ dialogType == "assessment" ? "标题" : "题目" }}
              <span class="c999 ml10" v-if="dialogType !== 'assessment'">
                <i class="el-icon-warning-outline"></i>
                无需输入题号，系统会自动添加阿拉伯数字“1.2.3”作为题号
              </span>
            </div>
            <div>
              <el-form-item
                class="no-margin-top"
                label-width="0px"
                prop="formTitle"
                :rules="[
                  {
                    required: true,
                    message: '不能为空',
                    trigger: 'blur',
                  },
                ]"
              >
                <el-input
                  class="input-title"
                  v-model="dialogForm.formTitle"
                  placeholder="请输入内容"
                ></el-input>
              </el-form-item>
            </div>
          </div>
          <!-- table -->
          <el-table
            class="dialog-table"
            :data="dialogForm.item"
            style="width: 100%"
          >
            <!-- 考核科目编辑内容 -->
            <el-table-column
              v-if="dialogType == 'assessment'"
              :label="`考核科目(共${assessmentItemNum}项)`"
              width="500px"
              align="left"
            >
              <template slot-scope="scope">
                <el-form-item
                  label-width="0"
                  :prop="'item.' + scope.$index + '.content'"
                  :rules="[
                    {
                      required: true,
                      message: '请输入考核内容',
                      trigger: 'blur',
                    },
                  ]"
                >
                  <el-input
                    type="text"
                    v-model="scope.row.content"
                    :placeholder="`请输入考核内容${scope.$index + 1}`"
                  ></el-input>
                </el-form-item>
              </template>
            </el-table-column>
            <!-- 题目编辑内容 -->
            <el-table-column
              v-else
              :label="`选择内容(共${assessmentItemNum}项)`"
              width="840px"
              align="left"
            >
              <template slot="header">
                <span> {{ `选择内容(共${assessmentItemNum}项)` }}</span>
                <span
                  class="c999 ml10 fw-normal"
                  v-if="dialogType !== 'assessment'"
                >
                  <i class="el-icon-warning-outline"></i>
                  无需输入题号，系统会自动添加英文字母“A.B.C”作为题号
                </span>
              </template>
              <template slot-scope="scope">
                <el-form-item
                  label-width="0"
                  :prop="'item.' + scope.$index + '.content'"
                  :rules="[
                    {
                      required: true,
                      message: '请输入选项内容',
                      trigger: 'blur',
                    },
                  ]"
                >
                  <el-input
                    type="text"
                    v-model="scope.row.content"
                    :placeholder="`请输入选项${scope.$index + 1}`"
                  ></el-input>
                </el-form-item>
              </template>
            </el-table-column>
            <el-table-column label="" width="50" align="center">
              <template slot-scope="scope">
                <el-form-item label-width="0">
                  <i
                    class="e6-icon-delete_fill"
                    @click="deleteItem(scope.$index)"
                  ></i>
                </el-form-item>
              </template>
            </el-table-column>
            <el-table-column
              min-width="100"
              align="left"
              v-if="dialogType == 'assessment'"
            >
              <template slot="header">
                <el-popover
                  placement="top-start"
                  width="300"
                  trigger="hover"
                  popper-class="score-tips"
                >
                  <div>
                    <p>通过设置科目分数，可控制考核的类型是加分或扣分：</p>
                    <p>①扣分考核，需要输入对应的科目总分数；</p>
                    <p>②加分考核，科目总分数输入0即可</p>
                  </div>
                  <i class="el-icon-warning-outline" slot="reference"></i>
                </el-popover>
                <span>
                  {{
                    dialogType == "assessment"
                      ? `科目分数(共${totalScore}分)`
                      : `可分配/选项最高分（${canUseScore}/${maxScore}分）`
                  }}</span
                >
              </template>
              <template slot-scope="scope">
                <el-form-item
                  label-width="0"
                  :prop="'item.' + scope.$index + '.score'"
                  :rules="[
                    {
                      required: true,
                      message: '不能为空',
                      trigger: 'blur',
                    },
                    { validator: numValidator, trigger: 'blur' },
                  ]"
                >
                  <el-input
                    type="text"
                    v-model.number="scope.row.score"
                    placeholder="请输入科目总分"
                  ></el-input>
                </el-form-item>
              </template>
            </el-table-column>
            <el-table-column
              min-width="110"
              align="left"
              v-if="dialogType == 'assessment'"
            >
              <template slot-scope="scope">
                <el-form-item
                  label-width="0"
                  :prop="'item.' + scope.$index + '.rate'"
                  :rules="[
                    {
                      required: true,
                      message: '不能为空',
                      trigger: 'blur',
                    },
                    { validator: rateValidator, trigger: 'blur' },
                  ]"
                >
                  <el-input
                    type="text"
                    v-model="scope.row.rate"
                    placeholder="请输入占比"
                  >
                    <template slot="append">%</template>
                  </el-input>
                </el-form-item>
              </template>
            </el-table-column>
          </el-table>
          <!-- 添加考核内容按钮 -->
          <div class="add-item-btn">
            <el-button type="primary" plain @click="handleAddItem">
              +
              {{ dialogType == "assessment" ? "添加考核内容" : "添加选项" }}
            </el-button>
          </div>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="submitAssessmentDorm">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { cloneDeep } from "lodash";
// api
import { saveSelfFormData } from "@/api/businessApplication";
export default {
  // name: "selfAssessmentForm",
  props: {
    pageType: {
      type: String,
      default: "add",
    },
  },
  data() {
    // 分数校验
    var numValidator = (rule, value, callback) => {
      if (value === "") {
        return callback(new Error("不能为空"));
      }

      if (!Number.isInteger(value)) {
        callback(new Error("请输入数字值"));
      } else {
        if (value < 0) {
          callback(new Error("不能输入负数"));
        } else {
          callback();
        }
      }
    };
    // 占比校验
    var rateValidator = (rule, value, callback) => {
      if (value === "") {
        return callback(new Error("不能为空"));
      }
      let reg = /^\d+(\.\d{1,2})?$/;
      if (reg.test(value)) {
        callback();
      } else {
        callback(new Error("请输入非负数，最多两位小数"));
      }
    };
    return {
      loading: false,
      numValidator: numValidator,
      rateValidator: rateValidator,
      dialogType: "assessment",
      // -----标题&考核项编辑----
      dialogVisible: false,
      dialogForm: {
        isFile: false,
        formTitle: "企业自评表",
        item: [
          {
            content: "",
            score: "",
            value: "",
            rate: "",
          },
          {
            content: "",
            score: "",
            value: "",
            rate: "",
          },
          {
            content: "",
            score: "",
            value: "",
            rate: "",
          },
          {
            content: "",
            score: "",
            value: "",
            rate: "",
          },
        ],
        subjectContent: "",
      },
      assessmentItemNum: 0,
      assessmentItemForm: {},
      oldAssessmentItemForm: {},
      removeItem: [], // 移除的考核项
      // -----题目编辑----
      editIndex: "",
      subjectList: [],
      options: [],
      refreshKey: new Date().getTime(),
      // 表单数据
      tableKey: new Date().getTime(),
      formData: [],
      formTableData: [{ name: "科目占比" }, { name: "科目分数" }],
      enArr: [
        "A",
        "B",
        "C",
        "D",
        "E",
        "F",
        "G",
        "H",
        "I",
        "J",
        "K",
        "L",
        "M",
        "N",
        "O",
        "P",
        "Q",
        "R",
        "S",
        "T",
        "U",
        "V",
        "W",
        "X",
        "Y",
        "Z",
      ],
    };
  },
  computed: {
    totalScore() {
      let res = this.dialogForm.item.reduce((total, currentValue) => {
        let temp = Number(currentValue.score) || 0;
        return total + temp;
      }, 0);
      return res;
    },
    // 编辑题目时的可分配分数
    canUseScore() {
      if (
        !Array.isArray(this.dialogForm.subjectContent) &&
        this.dialogForm.subjectContent !== ""
      ) {
        // 查找关联考核项的所有题目
        let temp = this.subjectList.filter((v, i) => {
          if (this.editIndex !== "") {
            // 点击编辑后算可分配的分数，需要剔除调当前编辑的数据的分数
            return (
              v.subjectContent == this.dialogForm.subjectContent &&
              i !== this.editIndex
            );
          } else {
            return v.subjectContent == this.dialogForm.subjectContent;
          }
        });
        if (temp.length) {
          // 计算所有关联考核项的题目的最高分的总和
          let tempTotal = temp.reduce((total, currentValue) => {
            return total + Number(currentValue.maxScore);
          }, 0);
          // 当期选择的考核项的总分减去已关联题目的最高分的总和，就是可分配的分数
          let tempCanUse =
            Number(this.dialogForm.subjectContent.split("-")[1]) - tempTotal;

          return tempCanUse;
        } else {
          return this.dialogForm.subjectContent.split("-")[1];
        }
      } else {
        return 0;
      }
    },
    // 编辑题目时的当前最高分
    maxScore() {
      if (
        !Array.isArray(this.dialogForm.subjectContent) &&
        this.dialogForm.subjectContent !== ""
      ) {
        let scoreArr = this.dialogForm.item.map((v) => {
          let score = 0;
          if (v.score !== "" && !isNaN(v.score)) {
            score = v.score;
          } else {
            score = 0;
          }
          return score;
        });
        let maxScore = Math.max.apply(null, scoreArr);
        return maxScore;
      } else {
        return 0;
      }
    },
  },
  watch: {
    "dialogForm.item": {
      handler: function (val) {
        this.assessmentItemNum = val.length;
      },
    },
  },
  mounted() {
    this.assessmentItemNum = this.dialogForm.item.length;
  },
  methods: {
    // --------------------------------------标题&考核项编辑弹框-----------------
    openDialog(val) {
      this.refreshKey = new Date().getTime();
      if (this.pageType === "detail") {
        return;
      }
      this.dialogType = val;
      if (this.dialogType == "subject") {
        this.dialogForm.formTitle = "题目";
        this.options = cloneDeep(this.assessmentItemForm.item);
      } else {
        if (Object.keys(this.assessmentItemForm).length) {
          this.dialogForm.item = this.assessmentItemForm.item;
          this.dialogForm.isFile = this.assessmentItemForm.isFile;
          this.dialogForm.formTitle = this.assessmentItemForm.formTitle;
          this.dialogForm.subjectContent = "";
          this.oldAssessmentItemForm = cloneDeep(this.dialogForm);
        }
      }
      this.dialogVisible = true;
    },
    // 关闭弹出框
    handleClose(type) {
      if (type == "save" && this.dialogType == "assessment") {
        this.dialogVisible = false;

        this.assessmentItemForm = cloneDeep(this.dialogForm);
        this.oldAssessmentItemForm = cloneDeep(this.dialogForm);
        this.removeItem = [];
      }
      if (type == "save" && this.dialogType == "subject") {
        this.dialogVisible = false;
        let scoreArr = this.dialogForm.item.map((v) => Number(v.score));
        let maxScore = Math.max.apply(null, scoreArr);
        this.dialogForm.maxScore = maxScore;
        if (this.editIndex !== "") {
          // 编辑
          this.subjectList.splice(
            this.editIndex,
            1,
            cloneDeep(this.dialogForm)
          );
        } else {
          // 新增
          this.subjectList.push(cloneDeep(this.dialogForm));
        }
      }
      // 自评表汇总表格展示及分数统计;
      this.setAssessmentTable();
      this.dialogType = "assessment";
      this.dialogForm.item = [
        {
          content: "",
          score: "",
          value: "",
        },
        {
          content: "",
          score: "",
          value: "",
        },
        {
          content: "",
          score: "",
          value: "",
        },
        {
          content: "",
          score: "",
          value: "",
        },
      ];
      this.dialogForm.formTitle = "企业自评表";
      this.dialogForm.isFile = false;
      this.dialogForm.subjectContent = "";
      this.editIndex = "";
      this.dialogVisible = false;
    },
    //  设置添加题目后的自评表汇总表格展示及分数统计
    setAssessmentTable() {
      if (!this.assessmentItemForm.item) {
        return;
      }
      // 拼接自评表表格数据
      let totalScore = 0;
      let totalRateScore = 0;
      // let settingTotalScore = 0;
      this.assessmentItemForm.item.forEach((v) => {
        totalScore = Number(totalScore) + Number(v.score);
        totalRateScore = Number(totalRateScore) + Number(v.rate);
        this.formTableData[0][`${v.content}-value`] = v.rate;
        this.formTableData[1][`${v.content}-value`] = Number(v.score);
        // // 筛选已关联的题目
        // let relationSubject = this.subjectList.filter((n) => {
        //   return v.content == n.subjectContent.split("-")[0];
        // });
        // let scoreArr = [];
        // // 计算已设置的分数，取每个题目的最高得分的总和
        // if (relationSubject.length) {
        //   relationSubject.forEach((subject) => {
        //     let score = subject.item.map((k) => Number(k.score));
        //     let maxScore = Math.max.apply(null, score);
        //     scoreArr.push(maxScore);
        //   });
        //   let tempScore = scoreArr.reduce((total, currentValue) => {
        //     let temp = Number(currentValue) || 0;
        //     return total + temp;
        //   }, 0);
        //   this.formTableData[0][`${v.content}-settingScore`] = tempScore;
        //   settingTotalScore = Number(settingTotalScore) + Number(tempScore);
        // }
      });
      this.formTableData[0].totalScore = totalRateScore;
      this.formTableData[1].totalScore = totalScore;

      this.tableKey = new Date().getTime();
    },
    // 添加考核内容
    handleAddItem() {
      this.dialogForm.item.push({
        content: "",
        store: "",
      });
    },
    // 删除考核内容
    deleteItem(index) {
      this.dialogForm.item.splice(index, 1);
    },
    // 删除题目
    deleteSubjectItem(i) {
      this.subjectList.splice(i, 1);
      this.setAssessmentTable();
    },
    // 编辑题目
    editSubjectItem(i) {
      this.editIndex = i;
      this.dialogType = "subject";
      this.dialogForm = cloneDeep(this.subjectList[i]);
      this.dialogVisible = true;
    },
    // 提交标题&考核项编辑弹框
    submitAssessmentDorm() {
      this.$refs.dialogForm.validate((valid) => {
        if (valid) {
          // 考核项提交
          if (this.dialogType == "assessment") {
            // 判断是否删除考核项
            if (Object.keys(this.oldAssessmentItemForm).length) {
              this.removeItem = this.oldAssessmentItemForm.item.filter((v) => {
                return this.dialogForm.item.every(
                  (n) => n.content != v.content
                );
              });
              // 有删除移除考核项的关联题目
              if (this.removeItem.length) {
                this.$confirm(
                  "删除考核项后，则该考核项下对应的所有题目也将被删除！",
                  "考核项变更确认",
                  {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    closeOnClickModal: false,
                    closeOnPressEscape: false,
                    type: "warning",
                  }
                )
                  .then(async () => {
                    this.subjectList = this.subjectList.filter((v) => {
                      return this.removeItem.every(
                        (n) => n.content != v.subjectContent.split("-")[0]
                      );
                    });
                    this.handleClose("save");
                  })
                  .catch(() => {});
              } else {
                this.subjectList = this.subjectList.filter((v) => {
                  return this.removeItem.every(
                    (n) => n.content != v.subjectContent.split("-")[0]
                  );
                });
                this.handleClose("save");
              }
            } else {
              this.handleClose("save");
            }
          }
          // 题目提交
          if (this.dialogType == "subject") {
            this.handleClose("save");
          }
        }
      });
    },
    // 提交生成的自定义评价表
    async submitAllForm(type) {
      try {
        this.loading = true;
        // 组装参数
        let params = {
          annexOpen: this.assessmentItemForm.isFile ? 1 : 0,
          appraisalName: this.assessmentItemForm.formTitle,
          appraisalCheckTopicList: [],
          appraisalStatus: type,
          appraisalSelfId: this.$route.query.appraisalSelfId || "",
        };
        if (Array.isArray(this.assessmentItemForm.item)) {
          this.assessmentItemForm.item.forEach((v) => {
            params.appraisalCheckTopicList.push({
              appraisalContent: v.content,
              appraisalFraction: v.score,
              proportionStr: v.rate,
              appraisalCheckHeadingList: [],
            });
          });
        }
        this.subjectList.forEach((v, subjectIndex) => {
          let index = params.appraisalCheckTopicList.findIndex(
            (n) => n.appraisalContent == v.subjectContent.split("-")[0]
          );
          if (index >= 0) {
            let curItem =
              params.appraisalCheckTopicList[index].appraisalCheckHeadingList;
            let subjectObj = {
              appraisalCheckHeadingContent: v.formTitle,
              appraisalCheckAnswerList: [],
              sort: subjectIndex,
            };
            v.item.forEach((obj) => {
              subjectObj.appraisalCheckAnswerList.push({
                appraisalCheckAnswerContent: obj.content,
                appraisalCheckAnswerFraction: obj.score,
              });
            });
            curItem.push(subjectObj);
          }
        });
        if (type == 1) {
          let tips = "确定发起自评，发起后表单将不可修改？";
          if (this.$route.query.appraisalStatus == 1) {
            tips =
              "表单已发起，若重新下发，则之前已下发、填写的数据将被删除，操作不可逆！";
          }
          this.$confirm(tips, "发起确认", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          })
            .then(async () => {
              // 保存数据;
              let res = await saveSelfFormData(params);
              if (res.code) {
                this.$message.success("保存成功");
                this.goBack();
              } else {
                this.$message.warning(res.message);
              }
            })
            .catch(() => {});
        } else {
          // 保存数据
          let res = await saveSelfFormData(params);
          if (res.code) {
            this.$message.success("保存成功");
            this.goBack();
          } else {
            this.$message.warning(res.message);
          }
        }
      } catch (err) {
        console.log(err);
      } finally {
        this.loading = false;
      }
    },
    // 返回
    goBack() {
      this.$router.push({
        path: "/customSelfAssessmentFrom",
      });
    },
    //------------编辑自评表------------
    //回显数据
    init(data) {
      // 考核项
      this.assessmentItemForm.formTitle = data.appraisalName;
      this.assessmentItemForm.isFile = data.annexOpen == 1 ? true : false;
      this.assessmentItemForm.item = new Array();
      data.appraisalCheckTopicList.forEach((v) => {
        this.assessmentItemForm.item.push({
          content: v.appraisalContent,
          score: v.appraisalFraction,
          rate: v.proportionStr,
          value: "",
        });
      });
      // 题目
      data.appraisalCheckTopicList.forEach((v) => {
        v.appraisalCheckHeadingList.forEach((item) => {
          let answerList = item.appraisalCheckAnswerList.map((n) => {
            return {
              content: n.appraisalCheckAnswerContent,
            };
          });
          let subjectObj = {
            formTitle: item.appraisalCheckHeadingContent,
            subjectContent: `${v.appraisalContent}-${v.appraisalFraction}`,
            item: cloneDeep(answerList),
            sort: item.sort,
          };

          this.subjectList.push(subjectObj);
        });
      });
      this.subjectList.sort(this.arraySort("sort"));
      //  添加题目的选项
      this.options = cloneDeep(this.assessmentItemForm.item);
      //设置添加题目后的自评表汇总表格展示及分数统计
      this.setAssessmentTable();
    },
    //自定义排序方法
    arraySort(p) {
      return function (m, n) {
        var a = m[p];
        var b = n[p];
        return a - b; //升序
      };
    },
  },
};
</script>
<style lang="scss" scoped>
.cRed {
  margin-right: 5px;
  color: red;
}
.c999 {
  color: #999;
}
.fw-normal {
  font-weight: normal;
}
.ml10 {
  margin-left: 10px;
}
.self-assessment-form {
  .add-item {
    margin: 0 50px;
    border-bottom: 1px dashed #ddd;
    h2 {
      font-size: 26px;
      text-align: center;
    }
  }
  .add-title {
    margin-left: 50px;
    margin-top: 20px;
  }
  .assessment-item {
    margin: 0 50px;
    padding: 0 0px 30px;
    border-bottom: 1px dashed #ddd;
    .subject-title {
      text-align: center;
      font-size: 26px;
    }
  }

  .btn-group {
    width: calc(100% - 70px);
    padding: 15px;
    text-align: center;
    position: absolute;
    left: 20px;
    bottom: 0px;
    background: #fff;
    box-shadow: 0 0 10px #eee;
  }
}
// dialog
/deep/ .el-dialog {
  width: 930px !important;
  .dialog-title {
    position: relative;
    padding: 8px 20px;
    background: #f1f1f1;
    border: 1px solid #ddd;
    &.no-border-bottom {
      border-bottom: none;
    }
    .pos-right {
      position: absolute;
      right: 30px;
    }
  }
  .el-dialog__footer {
    text-align: center;
  }
  .el-form-item--mini.el-form-item {
    margin: 13px 0;
  }
  .no-margin-top {
    margin-top: 0 !important;
  }
  .el-table {
    max-height: 300px;
    overflow: auto;
    &::before {
      display: none;
    }
    th.el-table__cell {
      background: #f1f1f1 !important;
    }
  }
  .el-table--mini td {
    padding: 0;
    border-bottom: none !important;
  }
  .e6-icon-delete_fill {
    cursor: pointer;
    font-size: 18px;
    color: #666;
  }
  .input-title {
    .el-input__inner {
      height: 50px;
      line-height: 50px;
    }
  }
  .add-item-btn {
    margin: 15px 0;
  }
  .el-input-group__append {
    /deep/ .el-input__inner {
      border-right: none !important;
    }
    padding: 0 10px;
    background: #fff;
    // border: none;
  }
}

//  问卷
.subject-wrapper {
  padding: 20px 50px;
  padding-bottom: 50px;
  .subject-item {
    margin-bottom: 30px;
    // border-bottom: 1px solid #efefef;
    .answer-item {
      padding-left: 20px;
    }
    /deep/ .el-radio-group {
      width: 100%;
    }
    /deep/ .el-radio {
      display: block !important;
      width: 100%;
      margin-top: 5px;
      .el-radio__label {
        display: inline-block;
        width: calc(100% - 0px);
        > span {
          display: block;
          width: 100%;
          word-wrap: break-word;
          white-space: pre-line;
        }
      }
    }
  }
}
</style>
<style lang="scss">
.score-tips {
  p {
    margin: 5px 0;
  }
}
</style>
